const DASHBOARD_HOSTNAME = 'dashboard.scale.com';
const REMOTASKS_HOSTNAME = 'remotasks.com';
const OUTLIER_HOSTNAME = 'app.outlier.ai';

function getExternalAppUrl({
  externalAppName,
  hostname,
  assignmentId,
}: {
  externalAppName: string;
  hostname: string;
  assignmentId: string;
}) {
  const baseUrl = getExternalAppBaseUrl({
    externalAppName,
    hostname,
  });

  return `${baseUrl}/assignment/${assignmentId}`;
}

export const useExternalAppUrl = ({
  externalAppName,
  assignmentId,
}: {
  externalAppName: string;
  assignmentId: string;
}) => {
  return getExternalAppUrl({
    externalAppName,
    hostname: location.hostname,
    assignmentId,
  });
};

function getExternalAppBaseUrl({
  externalAppName,
  hostname,
}: {
  externalAppName: string;
  hostname: string;
}) {
  const isLocalHost = location.hostname === 'localhost';
  if (isLocalHost) {
    hostname = OUTLIER_HOSTNAME;
  }

  if (![DASHBOARD_HOSTNAME, REMOTASKS_HOSTNAME, OUTLIER_HOSTNAME].includes(hostname)) {
    throw new Error(`Unknown hostname for external app: ${externalAppName}`);
  }

  return `https://${externalAppName}.${hostname}`;
}

export const useExternalAppBaseUrl = ({ externalAppName }: { externalAppName: string }) => {
  return getExternalAppBaseUrl({
    externalAppName,
    hostname: location.hostname,
  });
};
